import { BorderedContainer } from 'core/components/common/BorderedContainer';
import { IncidentDetailPatient } from '../useIncidentDetailForHiroshima';
import { SectionTitle } from 'core/components/common/SectionTitle';
import { PdfItem } from 'core/components/JianDetail/PatientDetailInfo/ActivityRecordPdf/PdfItem';
import { DataNotFound } from 'core/components/common/DataNotFound';
import { FC } from 'react';

type Props = {
  activityRecordPdf: IncidentDetailPatient['activityRecordPdf'];
  nonTransportPdf: IncidentDetailPatient['nonTransportPdf'];
};

export const DocumentsView: FC<Props> = ({ activityRecordPdf, nonTransportPdf }) => {
  return (
    // BorderedContainer 間でマージンを取る
    <div className="flex flex-col gap-[24px]">
      <BorderedContainer>
        <div className="flex flex-col gap-[24px]">
          <SectionTitle text="活動記録表PDF" />
          {activityRecordPdf.length > 0 ? (
            activityRecordPdf.map(pdf => (
              <PdfItem key={pdf.documentId} pdf={pdf} />
            ))
          ) : (
            <DataNotFound msg="活動記録表は作成されていません" />
          )}
        </div>
      </BorderedContainer>
      <BorderedContainer>
        <div className="flex flex-col gap-[24px]">
          <SectionTitle text="不搬送証明書PDF" />
          {nonTransportPdf.length > 0 ? (
            nonTransportPdf.map(pdf => (
              <PdfItem key={pdf.documentId} pdf={pdf} />
            ))
          ) : (
            <DataNotFound msg="不搬送証明書は作成されていません" />
          )}
        </div>
      </BorderedContainer>
    </div>
  );
};
